import React from 'react';
import { Helmet } from 'react-helmet';

import NavigationBar from '../NavigationBar';
import Footer from '../Footer';
import { useTranslation } from '../../i18n';

// Thin page: the canonical terms live on the marketing site
// (securepaper.app/terms, PL: /pl/terms) so the text exists in one place.
const Terms = () => {
  const { t, lang } = useTranslation();
  const url = lang === 'pl'
    ? 'https://securepaper.app/pl/terms'
    : 'https://securepaper.app/terms';

  return (
    <>
      <Helmet>
        <title>Terms of Service - SecurePaper</title>
        <meta name="description" content="SecurePaper's terms of service and user agreement." />
        <link rel="canonical" href="https://securepaper.app/terms" />
      </Helmet>
      <NavigationBar />

      <div className="container">
        <div className="py-5 text-center" style={{ minHeight: '50vh' }}>
          <h1>{t('legal.termsTitle')}</h1>
          <p className="text-muted mx-auto mt-3" style={{ maxWidth: '560px' }}>
            {t('legal.canonicalNote')}
          </p>
          <a href={url} className="btn btn-primary mt-3">
            <i className="fa fa-arrow-up-right-from-square mr-2" aria-hidden="true"></i>
            {t('legal.openFull')}
          </a>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Terms;
